import { get } from "lodash";
import { useContext, useMemo, useRef } from "react";
import { useTranslation } from "react-i18next";
import { MdAttachFile, MdEmail, MdSend } from "react-icons/md";
import TextEditor from "shared/components/TextEditor";
import { NAME_SPACES } from "shared/locales/constants";
import { StoreContext } from "shared/store";
import ActionButtons from "../Components/ActionButtons";
import buildEditorBlocks from "./buildEditorBlocks";

const EmailPreview = ({ onSend, onCancel, clientEmail, project, loading }) => {
  const { user } = useContext(StoreContext);
  const { t } = useTranslation(NAME_SPACES.PRIVATE.BROKER.PROJECT);
  const DETAIL = t("DETAIL", { returnObjects: true });
  const editorCore = useRef(null);
  const defaultValue = useMemo(
    () =>
      buildEditorBlocks({
        emailContent: {},
        mailTranslations: DETAIL.TEMPLATES.QUOTE.MAIL,
        project,
        user,
      }),
    [],
  );

  return (
    <div className="ep">
      <div className="ep__header">
        <div className="ep__header-icon">
          <MdEmail size={20} />
        </div>
        <div>
          <h2 className="ep__title">Prévisualisation de l'email</h2>
          <p className="ep__subtitle">
            Modifiez le message avant l'envoi si nécessaire
          </p>
        </div>
      </div>

      <div className="ep__fields">
        <div className="ep__field-row">
          <span className="ep__field-label">De:</span>
          <span className="ep__field-value">{get(user, "email", "")}</span>
        </div>
        <div className="ep__field-row">
          <span className="ep__field-label">À:</span>
          <span className="ep__field-value">{clientEmail}</span>
        </div>
        <div className="ep__field-row">
          <span className="ep__field-label">Objet:</span>
          <span className="ep__field-value">
            Votre devis personnalisé Kayros
          </span>
        </div>
        <div className="ep__field-row">
          <span className="ep__field-label">Pièce jointe:</span>
          <span className="ep__attachment">
            <MdAttachFile size={14} />
            devis-kayros.pdf
          </span>
        </div>
      </div>

      <div className="ep__message-section">
        <div className="ep__message-label">
          <MdEmail size={14} />
          Message
        </div>
        <div className="ep__message-content">
          <TextEditor
            defaultValue={defaultValue}
            ref={editorCore}
            i18n={DETAIL.TEMPLATES.QUOTE.TEXT_EDITOR}
          />
        </div>
      </div>

      <p className="ep__note">
        Ce message sera envoyé au client avec le devis en pièce jointe.
      </p>

      <ActionButtons
        onBack={onCancel}
        onSubmit={async () => {
          const template = await editorCore.current.handleSave();
          onSend({ template });
        }}
        icons={{ next: <MdSend size={18} />, previous: null }}
        loading={loading}
        translation={{
          PREVIOUS: "Annuler",
          NEXT: "Confirmer et envoyer le devis",
        }}
      />
    </div>
  );
};

export default EmailPreview;
